export async function blobToDataURL (blob) {
  return new Promise((fulfill, reject) => {
      let reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => fulfill(reader.result);
      reader.readAsDataURL(blob);
  })
}